import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { CopyIcon } from '@/shared/assets/icons/copy-icon';
import { TCopyIdButtonProps } from '@/shared/components/ui/copy-id-button/copy-id-button.types';
import { Trigger } from '@/shared/components/ui/trigger/trigger';

export const CopyIdButton: React.FC<TCopyIdButtonProps> = ({
  id,
  component = 'Button',
  buttonSize = 'small',
  buttonVariant = 'secondary',
  label,
  tooltip,
  ...triggerProps
}) => {
  const { t } = useTranslation();

  if (!id) {
    return null;
  }

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(id);
    toast.success(t('common:copied_to_clipboard'));
  };

  return (
    <Trigger
      tooltip={tooltip ?? id}
      component={component}
      buttonVariant={buttonVariant}
      buttonSize={buttonSize}
      onClick={copyToClipboard}
      label={label ?? t('common:copy_id')}
      icon={<CopyIcon />}
      {...triggerProps}
    />
  );
};
